import type { CopyCatalog } from "./copyTypes";

export const HU_COPY: CopyCatalog = {
  "common.loading": "Betöltés…",
  "common.yes": "Igen",
  "common.no": "Nem",
  "common.notProvided": "Nincs megadva",
  "common.notRequired": "Nem szükséges",
  "common.requested": "Igényelve",
  "nav.back": "Vissza",
  "nav.continue": "Tovább",
  "nav.sendRequest": "Kérelem küldése",
  "nav.sending": "Küldés…",
  "alert.completeFields": "A folytatás előtt töltse ki a kiemelt mezőket.",
  "fill.filled": "Kitöltve",
  "fill.notFound": "Nem található",
  "fill.shipmentToo": "A küldemény is kitöltve: {detail}",
  "fill.palletMany": "raklap",

  "choose.title": "Hogyan szeretné kérni az árajánlatot?",
  "choose.manual.title": "Kézi kitöltés",
  "choose.manual.description": "Adja meg a küldemény adatait lépésről lépésre a vezetett űrlapon.",
  "choose.manual.action": "Adatok megadása kézzel",
  "choose.quickfill.title": "Quick Fill",
  "choose.quickfill.description":
    "Illessze be a küldemény adatait vagy töltsön fel egy dokumentumot, és mi kitöltjük az űrlapot.",
  "choose.quickfill.action": "Gyors kitöltés indítása",

  "steps.route": "Útvonal és rendelés",
  "steps.shipment": "Küldemény",
  "steps.services": "További szolgáltatások",
  "steps.contact": "Kapcsolat",
  "steps.review": "Ellenőrzés",

  "page.route": "Útvonal és rendelés",
  "page.routeSection": "Útvonal",
  "page.shipment": "Küldemény adatai",
  "page.services": "További szolgáltatások",
  "page.contact": "Kapcsolattartási adatok",
  "page.contactSection": "Az Ön kapcsolattartási adatai",
  "page.review": "Ellenőrzés",
  "page.quickFill": "Quick Fill",
  "page.analyzing": "A dokumentum elemzése",

  "route.hintPostcode": "Adjon meg irányítószámot vagy várost a fel- és lerakodáshoz.",
  "route.hintFullAddress": "Adja meg a teljes fel- és lerakodási címet.",
  "route.unsupported": "Ez az útvonal nem támogatott. Használja az űrlapot {loadCountry} és {unloadCountry} számára.",
  "route.loading": "Felrakodás",
  "route.unloading": "Lerakodás",
  "route.origin": "Indulás",
  "route.destination": "Cél",
  "route.country": "Ország",
  "route.selectCountry": "Válasszon országot",
  "route.postcode": "Irányítószám",
  "route.postcodePlaceholder": "pl. 1011",
  "route.city": "Város",
  "route.cityPlaceholder": "Adja meg a várost",
  "route.street": "Utcanév",
  "route.streetPlaceholder": "Adja meg az utcát",
  "route.house": "Házszám",
  "route.housePlaceholder": "pl. 12",
  "route.pickupDate": "Kívánt felvételi dátum:",
  "route.unloadDate": "Kívánt lerakodási dátum:",
  "route.datePlaceholder": "éééé.hh.nn.",
  "date.clear": "Dátum törlése",
  "date.closeCalendar": "Naptár bezárása",
  "date.openCalendar": "Naptár megnyitása",
  "route.specificDateHint":
    "Olyan árukhoz, amelyek egy adott napon állnak rendelkezésre. Egyébként a leggyorsabb opcióra törekszünk.",
  "route.orderDetails": "Rendelés adatai",

  "shipment.goods": "Áruleírás",
  "shipment.goodsPlaceholder": "Mit szeretne szállítani?",
  "shipment.weight": "Össztömeg",
  "shipment.qty": "Menny.",
  "shipment.type": "Típus",
  "shipment.dims": "Méretek / LDM",
  "shipment.stackable": "Rakásolható",
  "shipment.addRow": "Küldemény-sor hozzáadása",
  "shipment.totalLines": "Sorok száma: {count}",
  "shipment.selectDims": "Válasszon méreteket",
  "shipment.dimsNa": "A méretek nem alkalmazhatók",
  "shipment.sizeModeDims": "H × Sz × M",
  "shipment.sizeModeLdm": "LDM",
  "shipment.removeRow": "{n}. küldemény-sor törlése",
  "shipment.lineLabel": "{text}, {n}. sor",
  "shipment.quantity": "Mennyiség",
  "qty.decrease": "Mennyiség csökkentése",
  "qty.increase": "Mennyiség növelése",
  "shipment.lengthCm": "Hossz (cm)",
  "shipment.widthCm": "Szélesség (cm)",
  "shipment.heightCm": "Magasság (cm)",
  "shipment.dimensions": "Méretek",
  "shipment.size": "Méret",
  "shipment.ldm": "LDM",

  "pallet.euro": "Euro",
  "pallet.block": "Block",
  "pallet.ibc": "IBC",
  "pallet.cp3": "CP3",
  "pallet.half": "Fél raklap",
  "pallet.size80x60": "80×60",
  "pallet.size120x120": "120×120",
  "pallet.size150x80": "150×80",
  "pallet.custom": "Egyedi",
  "pallet.unspecified": "LDM",

  "services.aria": "További szolgáltatások",
  "services.pill.adr": "ADR",
  "services.pill.temp": "Hőmérséklet",
  "services.pill.tail": "Emelőhátfal",
  "services.pill.ftl": "FTL",
  "services.pill.time": "Időablak",
  "services.pill.ref": "Hivatkozás / megjegyzések",
  "services.pill.references": "Hivatkozások",
  "services.pill.attachments": "További mellékletek",
  "services.adrClass": "ADR osztály",
  "services.selectClass": "Válasszon osztályt",
  "services.unNumber": "UN-szám",
  "services.unPlaceholder": "pl. 1203",
  "services.min": "Min",
  "services.max": "Max",
  "services.tailLoad": "Emelőhátfal felrakodáskor",
  "services.tailUnload": "Emelőhátfal lerakodáskor",
  "services.ftlCopy": "Teljes kamionterhelés igényelve.",
  "services.invoiceRef": "Számla hivatkozás",
  "services.reference": "Hivatkozás",
  "services.loadingRef": "Felrakodási hivatkozás",
  "services.unloadingRef": "Lerakodási hivatkozás",
  "services.notes": "Megjegyzések",
  "services.notesPlaceholder": "pl. különleges utasítások",
  "services.deadline": "Kívánt szállítási határidő:",
  "services.deliveryHint":
    "Olyan árukhoz, amelyeket adott napon kell kézbesíteni. Egyébként a leggyorsabb opcióra törekszünk.",
  "services.loadingTime": "Felrakodási idő",
  "services.unloadingTime": "Lerakodási idő",
  "services.window": "Időablak",
  "services.fixed": "Rögzített",
  "services.at": "ekkor",
  "services.from": "ettől",
  "services.to": "eddig",
  "services.timeTypeAria": "{title} típusa",
  "services.addFiles": "Fájlok hozzáadása",
  "services.attachHint":
    "JPEG, PNG, GIF, WebP vagy PDF. Legfeljebb {maxFiles} fájl, fájlonként {maxFileMb} MB, összesen {maxTotalMb} MB.",
  "services.adrClass1": "1 Robbanóanyagok",
  "services.adrClass2": "2 Gázok",
  "services.adrClass3": "3 Gyúlékony folyadékok",
  "services.adrClass4": "4 Gyúlékony szilárd anyagok",
  "services.adrClass5": "5 Oxidáló anyagok",
  "services.adrClass6": "6 Mérgező / fertőző anyagok",
  "services.adrClass7": "7 Radioaktív anyagok",
  "services.adrClass8": "8 Maró anyagok",
  "services.adrClass9": "9 Egyéb veszélyes anyagok",
  "services.summary.adr": "Veszélyes áruk (ADR)",
  "services.summary.temp": "Hőmérséklet-ellenőrzött",
  "services.summary.time": "Időablakok",
  "services.summary.refNotes": "Hivatkozás és megjegyzések",
  "services.summary.tail": "Emelőhátfal",
  "services.summary.ftl": "FTL",
  "services.summary.attachments": "További mellékletek",
  "services.tail.loadUnload": "Fel- és lerakodás",
  "services.tail.loadOnly": "Csak felrakodás",
  "services.tail.unloadOnly": "Csak lerakodás",
  "services.time.load": "Felrakodás: {value}",
  "services.time.unload": "Lerakodás: {value}",
  "services.time.deadline": "Határidő: {value}",
  "services.time.fixedSuffix": "{time} (rögzített)",
  "services.time.windowRange": "{from}–{until}",
  "services.adr.yes": "Igen",
  "services.adr.classUn": "{class}. osztály, UN {un}",
  "services.adr.classOnly": "{class}. osztály",
  "services.adr.unOnly": "UN {un}",
  "services.temp.range": "{min}°C–{max}°C",
  "services.ref.invoice": "Számla: {value}",
  "services.ref.loading": "Felrakodás: {value}",
  "services.ref.unloading": "Lerakodás: {value}",

  "contact.name": "Név",
  "contact.company": "Cég",
  "contact.email": "E-mail",
  "contact.phone": "Telefon",
  "contact.comment": "További megjegyzés",
  "contact.privacyBefore":
    "Hozzájárulok személyes adataim kezeléséhez a Neele-Vat ",
  "contact.privacyLink": "adatvédelmi szabályzatának",
  "contact.privacyAfter": " megfelelően.",

  "result.thankYou": "Köszönjük! Kérelmét megkaptuk.",
  "result.teamWillContact":
    "Csapatunk 60 percen belül, hivatali időben felveszi Önnel a kapcsolatot.",
  "result.teamWillContactEmail":
    "Csapatunk 60 percen belül, hivatali időben felveszi Önnel a kapcsolatot a(z) {email} címen.",
  "result.previewMode": "Előnézeti mód — ez a kérelem valójában nem lett elküldve.",
  "result.previewFiles": " Megjegyzés: fájlok előnézeti módban nem küldhetők.",
  "result.yourReference": "Az Ön hivatkozása",
  "result.copy": "Másolás",
  "result.copied": "Másolva",
  "result.nextTitle": "Mi történik ezután",
  "result.next1": "Kérelem megérkezett.",
  "result.next2": "A kérelem feldolgozás alatt.",
  "result.next3": "Válasz 60 percen belül e-mailben.",
  "result.logged":
    "Rögzítettük a kérelmét. Ha nem hall rólunk, lépjen kapcsolatba velünk az alábbi adatokkal.",
  "result.newQuote": "Új ajánlat indítása",
  "result.sendFailed": "Nem tudtuk elküldeni a kérelmét",
  "result.preferDirect": "Inkább közvetlenül keresne meg minket?",
  "result.backToEdit": "Vissza a szerkesztéshez",
  "result.tryAgain": "Újrapróbálás",
  "result.hideDetails": "Részletek elrejtése",
  "result.viewSent": "Az elküldött adatok megtekintése",
  "result.error.rateLimited":
    "Rövid idő alatt sok kérelmet küldött. Várjon egy kicsit, majd próbálja újra.",
  "result.error.forbidden":
    "Ezt a kérelmet blokkoltuk. Próbálja újra, vagy lépjen velünk közvetlenül kapcsolatba.",
  "result.error.network":
    "Jelenleg nem tudtuk elküldeni a kérelmét. Ellenőrizze a kapcsolatot, majd próbálja újra.",
  "result.error.tooLarge":
    "A kérelem túl nagy a küldéshez. Használjon kisebb mellékleteket vagy rövidebb megjegyzést.",
  "result.error.unsupportedType": "Csak JPEG, PNG, GIF, WebP vagy PDF fájlokat használjon.",
  "result.error.emailUnavailable":
    "Nem tudtuk e-mailben elküldeni a kérelmet a mellékletekkel. Próbálja újra, vagy lépjen velünk közvetlenül kapcsolatba.",

  "qf.hint":
    "Illesszen be egy e-mailt vagy küldeményadatokat, vagy csatoljon képet vagy PDF-et. Ez felülírja a már megadott adatokat.",
  "qf.placeholder":
    "pl. 24 euro raklap 3011 Rotterdamból 20095 Hamburgba, 12 000 kg, holnapi felvétel…",
  "qf.ariaPaste": "Elemzendő küldeményadatok",
  "qf.attach": "Kép vagy PDF csatolása",
  "qf.disclaimer":
    "Minden beillesztett vagy csatolt anyag csak ennek a kérelemnek a kitöltésére szolgál. Dokumentumelemző szolgáltatásunk dolgozza fel, és az űrlap kitöltése után nem tároljuk.",
  "qf.fillForm": "Űrlap kitöltése",
  "qf.working": "Feldolgozás…",
  "qf.analyzing": "Az adatok elemzése…",
  "qf.noFields": "Nem ismerhető fel mező. Adjon meg több részletet.",
  "qf.rateLimited": "Túl sok kérelmet küldött. Várjon egy kicsit, majd próbálja újra.",
  "qf.blocked": "Ezt a kérelmet blokkoltuk. Lépjen kapcsolatba velünk, ha ez váratlan.",
  "qf.extractUnavailable":
    "A dokumentumelemzés jelenleg nem érhető el. Illessze be inkább a küldemény adatait.",
  "qf.genericError": "Valami hiba történt. Ellenőrizze a hálózatot, vagy próbálja újra.",
  "qf.analyzeTitle": "A dokumentum elemzése...",
  "qf.analyzeSub": "Ez általában néhány másodpercet vesz igénybe",
  "qf.analyzeStep1": "A dokumentum szerkezetének olvasása",
  "qf.analyzeStep2": "Alapadatok kinyerése",
  "qf.analyzeStep3": "Küldemény-sorok azonosítása",
  "qf.removeFile": "{name} eltávolítása",

  "error.loadCountry": "Válasszon felrakodási országot.",
  "error.loadPostal": "Adja meg a felrakodás irányítószámát.",
  "error.loadCity": "Adja meg a felrakodás városát.",
  "error.loadStreet": "Adja meg a felrakodás utcanevét.",
  "error.loadHouseNumber": "Adja meg a felrakodás házszámát.",
  "error.unloadCountry": "Válasszon lerakodási országot.",
  "error.unloadPostal": "Adja meg a lerakodás irányítószámát.",
  "error.unloadCity": "Adja meg a lerakodás városát.",
  "error.unloadStreet": "Adja meg a lerakodás utcanevét.",
  "error.unloadHouseNumber": "Adja meg a lerakodás házszámát.",
  "error.pickupDate": "Válasszon felvételi dátumot.",
  "error.unloadDate": "Válasszon lerakodási dátumot.",
  "error.invalidDate": "Adjon meg egy érvényes dátumot.",
  "error.totalWeight": "Adja meg az össztömeget.",
  "error.goods": "Írja le az árut.",
  "error.loadCityOrPostal": "Adja meg a felrakodás irányítószámát vagy városát.",
  "error.unloadCityOrPostal": "Adja meg a lerakodás irányítószámát vagy városát.",
  "error.loadPostalInvalid": "Adjon meg egy felismert felrakodási irányítószámot.",
  "error.loadCityInvalid": "Adjon meg egy felismert felrakodási várost.",
  "error.unloadPostalInvalid": "Adjon meg egy felismert lerakodási irányítószámot.",
  "error.unloadCityInvalid": "Adjon meg egy felismert lerakodási várost.",
  "error.pickupPast": "A felvételi dátum nem lehet a múltban.",
  "error.unloadPast": "A lerakodási dátum nem lehet a múltban.",
  "error.unloadBeforePickup": "A lerakodási dátum nem lehet korábbi a felvételinél.",
  "error.weightRange": "Adjon meg 1 és {max} kg közötti tömeget.",
  "error.rangePlain": "{min}–{max}.",
  "error.rangeLdm": "{min}–{max} LDM.",
  "error.rangeCm": "{min}–{max} cm.",
  "error.adrUn": "Adja meg a 4 számjegyű UN-számot.",
  "error.invoiceRef": "Adja meg a számla hivatkozását.",
  "error.loadingRef": "Adja meg a felrakodási hivatkozást.",
  "error.unloadingRef": "Adja meg a lerakodási hivatkozást.",
  "error.tempMin": "Adja meg a minimális hőmérsékletet.",
  "error.tempMax": "Adja meg a maximális hőmérsékletet.",
  "error.tempOrder": "A max legalább a min legyen.",
  "error.enterNumber": "Adjon meg egy számot.",
  "error.deliveryPast": "A szállítási határidő nem lehet a múltban.",
  "error.deliveryBeforePickup": "A szállítási határidő nem lehet korábbi a felvételinél.",
  "error.tailSides": "Válassza a felrakodást, a lerakodást vagy mindkettőt.",
  "error.attachOne": "Csatoljon legalább egy fájlt.",
  "error.enterTime": "Adjon meg egy időpontot.",
  "error.enterStartTime": "Adja meg a kezdő időpontot.",
  "error.enterEndTime": "Adja meg a záró időpontot.",
  "error.enterMinutes": "Adja meg a perceket.",
  "error.completeTime": "Adjon meg egy teljes időpontot.",
  "error.enterEmail": "Adja meg az e-mail-címét.",
  "error.validEmail": "Adjon meg érvényes e-mail-címet.",
  "error.validPhone": "Adjon meg érvényes telefonszámot.",
  "error.personalEmail": "Személyes e-mail-címek nem fogadhatók el.",
  "error.enterName": "Adja meg a nevét.",
  "error.enterCompany": "Adja meg a cégét.",
  "error.privacy": "A folytatáshoz fogadja el.",
  "error.quickFillEmpty":
    "Illesszen be küldeményadatokat, vagy csatoljon képet vagy PDF-et az űrlap kitöltéséhez.",
  "error.maxFiles": "Legfeljebb {max} fájlt csatolhat.",
  "error.maxFileMb": "Minden fájl legfeljebb {max} MB lehet.",
  "error.maxTotalMb": "A mellékletek összesen legfeljebb {max} MB lehetnek.",
  "error.filesSkippedType": "Egyes fájlokat kihagytunk. Használjon JPEG, PNG, GIF, WebP vagy PDF fájlokat.",
  "error.emptySkipped": "Az üres fájlokat kihagytuk.",
  "error.fileEmpty": "A kiválasztott fájl üres.",
  "error.filesEmptyOrType": "Egyes fájlok üresek voltak, vagy nem JPEG, PNG, GIF, WebP vagy PDF.",
  "error.attachType": "Csatoljon JPEG, PNG, GIF, WebP vagy PDF fájlt.",
  "error.subjectLong": "A tárgy túl hosszú.",
  "error.emailTextLong": "A kérelem adatai túl hosszúak.",
  "error.shortenSubject": "Rövidítse ezt az értéket, hogy az e-mail tárgya {max} karakteren belül maradjon.",
  "error.shortenBody":
    "Rövidítse a küldemény adatait vagy a megjegyzést, hogy az e-mail {max} karakteren belül maradjon.",

  "announce.choose": "Válassza ki, hogyan kéri az árajánlatot",
  "announce.quickfill": "Gyors kitöltés: illesszen be adatokat vagy töltsön fel dokumentumot",
  "announce.route": "1. lépés / 5: útvonal és rendelés",
  "announce.shipment": "2. lépés / 5: küldemény adatai",
  "announce.services": "3. lépés / 5: további szolgáltatások",
  "announce.contact": "4. lépés / 5: kapcsolattartási adatok",
  "announce.review": "5. lépés / 5: ellenőrizze a kérelmet",
  "announce.received": "Kérelem megérkezett",
  "announce.sendFailed": "Nem tudtuk elküldeni a kérelmét",
  "announce.sendFailedAttempt": "Nem tudtuk elküldeni a kérelmét ({n}. kísérlet)",
  "announce.completeFields": "A folytatás előtt töltse ki a kiemelt mezőket.",
  "announce.sending": "A kérelem küldése…",
};
